import userService from "../../../services/user.service";

async function getCustomerRanks() {
  try {
    const response = await userService.getCustomerRank(-1, 0, "");
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to fetch customer ranks."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching customer ranks:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function addCustomerRankToDatabase({ rankName, rankDescription }) {
  try {
    const payload = {
      rankName,
      rankDescription,
    };
    const response = await userService.addCustomerRank(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to add customer rank."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error adding customer rank:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function updateCustomerRankInDatabase({
  rankId,
  rankName,
  rankDescription,
}) {
  try {
    const payload = {
      customerRankId: rankId,
      rankName,
      rankDescription,
    };
    const response = await userService.updateCustomerRank(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to update customer rank."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error updating customer rank:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

export default {
  getCustomerRanks,
  addCustomerRankToDatabase,
  updateCustomerRankInDatabase,
  customerRankTools: [
    {
      type: "function",
      function: {
        name: "getCustomerRanks",
        description:
          "Fetch all customer ranks from the database. You must give all customer ranks in return. Don't skip any data unless instructed.",
        parameters: {
          type: "object",
          properties: {},
          required: [],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "addCustomerRankToDatabase",
        description: "Add a new customer rank to the database",
        parameters: {
          type: "object",
          properties: {
            rankName: {
              type: "string",
              description: "Name of the customer rank",
            },
            rankDescription: {
              type: "string",
              description: "Description of the customer rank",
            },
          },
          required: ["rankName", "rankDescription"],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "updateCustomerRankInDatabase",
        description: "Update an existing customer rank in the database",
        parameters: {
          type: "object",
          properties: {
            rankId: {
              type: "string",
              description: "The unique ID of the customer rank to be updated",
            },
            rankName: {
              type: "string",
              description: "Name of the customer rank",
            },
            rankDescription: {
              type: "string",
              description: "Description of the customer rank",
            },
          },
          required: ["rankId", "rankName", "rankDescription"],
        },
      },
    },
  ],
};
